import React, { Fragment } from 'react';
import { Calendar } from 'components/Calendar';
import { Views } from 'react-big-calendar';
import { makeStyles } from '@material-ui/core';
import './index.scss';
import cn from 'classnames';
import { severityRatingEnums } from 'containers/Pages/Events/Layouts';
import Loader from 'components/Loader';
import { transFormCalendarTask } from 'utils/DataTransform/Calendar/calendarList';
import PropTypes from 'prop-types';

// design payload according to this and add the data which may be required to perform other tasks
//   id: 1,
//   type: 'MAINTENANCE',
//   title: 'Lunch',
//   start: new Date(2023, 0, 5, 5, 0, 0),
//   end: new Date(2023, 0, 5, 13, 30, 0),

const formatEvents = ({
  cleaningTaskItems,
  workOrderTaskItems,
  securityTaskItems,
  patrolTaskItems,
  tripTaskItems,
}) => {
  const cleaningEvents = transFormCalendarTask(
    cleaningTaskItems?.dashboardItems,
    severityRatingEnums,
  );

  const workOrderEvents = transFormCalendarTask(
    workOrderTaskItems?.dashboardItems,
    severityRatingEnums,
  );
  const securityEvents = transFormCalendarTask(
    securityTaskItems?.dashboardItems,
    severityRatingEnums,
  );
  const patrolEvents = transFormCalendarTask(
    patrolTaskItems?.dashboardItems,
    severityRatingEnums,
  );
  const tripTaskEvents = transFormCalendarTask(
    tripTaskItems?.dashboardItems,
    severityRatingEnums,
  );

  return [
    ...cleaningEvents,
    ...workOrderEvents,
    ...securityEvents,
    ...patrolEvents,
    ...tripTaskEvents,
  ];
};

const useStyles = makeStyles(theme => {
  return {
    standardText: {
      backgroundColor: theme.palette.severity.notRated,
    },
    veryHighText: {
      backgroundColor: theme.palette.severity.high,
    },
    highText: {
      backgroundColor: theme.palette.severity.high,
    },
    medium: {
      backgroundColor: theme.palette.severity.medium,
    },
    lowText: {
      backgroundColor: theme.palette.severity.low,
    },
    veryLowText: {
      backgroundColor: theme.palette.severity.low,
    },
    CalendarContainer: {
      '& .rbc-time-view': {
        '& .rbc-label': {
          display: 'none',
        },
        '& .rbc-allday-cell': {
          height: '540px',
          maxHeight: 'unset',
          '& .rbc-row-content': {
            zIndex: 0,
          },
        },
        '& .rbc-time-content': {
          display: 'none',
        },
      },
      '& .rbc-today': {
        backgroundColor: theme.palette.secondary.main,
      },
      '& .rbc-btn-group': {
        '& button:nth-of-type(n)': {
          // select all buttons inside this class
          color: theme.palette.secondary.light,
          border: 'none',
          background: theme.palette.primary.main,
          cursor: 'pointer',
          marginRight: '5px',
          borderRadius: '0',
        },
      },
    },
    loader: {
      position: 'absolute',
      background: theme.palette.background.paper,
      opacity: '0.8',
      height: 'inherit',
      width: '-webkit-fill-available',
    },
  };
});

// eslint-disable-next-line react/prop-types
const EventWrapperComponent = ({ event, children }) => {
  const classes = useStyles();
  const newChildren = { ...children };
  const newChildrenProps = { ...newChildren.props };
  // eslint-disable-next-line react/prop-types
  switch (event.severityRating) {
    case severityRatingEnums.veryHigh:
      newChildrenProps.className = cn(
        newChildrenProps.className,
        classes.veryHighText,
      );

      break;
    case severityRatingEnums.high:
      newChildrenProps.className = cn(
        newChildrenProps.className,
        classes.highText,
      );
      break;
    case severityRatingEnums.medium:
      newChildrenProps.className = cn(
        newChildrenProps.className,
        classes.medium,
      );
      break;
    case severityRatingEnums.low:
      newChildrenProps.className = cn(
        newChildrenProps.className,
        classes.lowText,
      );
      break;
    case severityRatingEnums.veryLow:
      newChildrenProps.className = cn(
        newChildrenProps.className,
        classes.veryLowText,
      );
      break;

    default:
      newChildrenProps.className = cn(
        newChildrenProps.className,
        classes.standardText,
      );

      break;
  }

  newChildren.props = { ...newChildrenProps };

  return <div>{newChildren}</div>;
};

const CalendarWidget = ({
  cleaningTaskItems,
  workOrderTaskItems,
  securityTaskItems,
  patrolTaskItems,
  tripTaskItems,
  onRangeChange,
  date,
  loaded = false,
}) => {
  const classes = useStyles();

  const typeOfViews = {
    [Views.WORK_WEEK]: true,
  };
  // const formats = { // disable time shown with title
  //   eventTimeRangeFormat: () => {
  //     return '';
  //   },
  // };
  const calendarEvents = formatEvents({
    cleaningTaskItems,
    workOrderTaskItems,
    securityTaskItems,
    patrolTaskItems,
    tripTaskItems,
  });

  return (
    <Fragment>
      {loaded && <Loader outline={true} className={classes.loader} />}
      <Calendar
        // formats={formats}
        events={calendarEvents}
        date={date}
        steps={30}
        timeslots={2}
        typeOfViews={typeOfViews}
        defaultView={Views.WORK_WEEK}
        className={classes.CalendarContainer}
        eventWrapper={EventWrapperComponent}
        onRangeChange={onRangeChange}
      />
    </Fragment>
  );
};
CalendarWidget.propTypes = {
  cleaningTaskItems: PropTypes.object,
  workOrderTaskItems: PropTypes.object,
  patrolTaskItems: PropTypes.object,
  securityTaskItems: PropTypes.object,
  tripTaskItems: PropTypes.object,
  onRangeChange: PropTypes.func,
  date: PropTypes.object,
  loaded: PropTypes.bool,
};
export default CalendarWidget;
